/**
 * Модуль для работы с блоком 'Навигация (меню)'
 *
 */

( function() {
    'use strict';

    let mainNav;
    let btnMenu;
    let mainNavWidth = 0;
    let mainNavPositionX = 0;
    let touchStartX = 0;
    let transformIsSupport = null;
    let setMainMenuWidthTimeoutId = null;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        mainNav = document.querySelector('.main-nav');
        if (!mainNav) {
            return;
        }

        btnMenu = document.querySelector('.main-nav-btn-menu');

        onBtnMenuShow();
        onBtnMenuClose();
        onBtnMenuStateChange();

        let mainMenus = document.querySelectorAll('.main-menu');
        [].forEach.call(mainMenus, (menu) => {
            menu.addEventListener('click', onMainMenuItemClick);
        });

        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('click', onWindowClick);
        document.addEventListener('close-menu', closeMainMenu);
        window.addEventListener('orientationchange', setMainMenuWidth, false);

        if (isVisibleDesktopMenu()) {
            return;
        }

        setMainMenuWidth();
        if (isSupportTransform() && window.requestAnimationFrame) {
            document.addEventListener('touchstart', onDocumentTouchStart);
        } else {
            closeMainMenu();
        }

        //Специально добавлена проверка версии, т.к. до 8-ой версии был баг в работе ед.изм. vh
        let iOSVer = iOSVersion();
        if (isExistMobileMenu() && (!isSupportVh() || ((iOSVer > 0) && (iOSVer < 8)))) {
            setMainMenuHeight();
        }
    }

    function setMainMenuWidth() {
        mainNav.style.width = '';

        clearTimeout(setMainMenuWidthTimeoutId);
        setMainMenuWidthTimeoutId = setTimeout(function() {
            let width = mainNav.getBoundingClientRect().width;

            mainNav.style.width = width + 'px';
        }, 300);

    }

    function setMainMenuHeight() {
        let heightWindow = parseInt(window.innerHeight, 10);

        mainNav.style.height =
            String(Math.floor(heightWindow * 0.8)) + 'px';
    }

    function isSupportTransform() {
        if (transformIsSupport === null) {
            let style = getComputedStyle(mainNav);
            transformIsSupport = (style.getPropertyValue('transform') || style.getPropertyValue('webkitTransform'));
        }

        return transformIsSupport;
    }

    function isSupportVh() {
        let element = document.querySelector('.js-support');
        if (!element) {
            return true;
        }

        element.style.height = '50vh';

        let halfHeight = parseInt(window.innerHeight / 2, 10);
        let elementHeight = parseInt(getComputedStyle(element).height, 10);
        let isSupport = (halfHeight === elementHeight);

        element.style.height = '';

        return isSupport;
    }

    function isVisibleDesktopMenu() {
        return getComputedStyle(mainNav.querySelector('.main-menu--desktop')).display !== 'none';
    }

    function isExistMobileMenu() {
        return !!mainNav.querySelector('.main-menu--mobile');
    }

    function closeMainMenuItem() {
        let checkedElement = document.querySelector('.main-menu-item__state:checked');
        if (checkedElement) {
            checkedElement.checked = false;
        }

        let checkedElements = document.querySelectorAll('.main-menu-item__state--checked');
        [].forEach.call(checkedElements, (element) => {
            element.classList.remove('main-menu-item__state--checked');
        });
    }

    function openMainMenu() {
        mainNav.classList.add('main-nav--show');
        mainNav.classList.remove('main-nav--hide');
        mainNav.style.transform = '';

        selectedFirstItemMainMenu();
    }

    function closeMainMenu() {
        mainNav.classList.remove('main-nav--show');
        if (!isSupportTransform()) {
            mainNav.classList.add('main-nav--hide');
        }

        mainNav.style.transform = '';

        closeMainMenuItem();

        btnMenu.checked = false;

        let showMainMenu = document.querySelector('.main-menu--show');
        if (showMainMenu) {
            showMainMenu.classList.remove('main-menu--show');
        }
    }

    function isOpenMainMenu() {
        return mainNav.classList.contains('main-nav--show');
    }

    function selectedFirstItemMainMenu() {
        let mainMenu = getActiveMainMenu();
        if (!mainMenu) {
            return;
        }

        mainMenu.querySelector('.main-menu-item__state').checked = true;
    }

    function getActiveMainMenu() {
        let mainMenu = document.querySelector('.main-menu--desktop');
        if (getComputedStyle(mainMenu).display !== 'none') {
            return mainMenu;
        }

        return document.querySelector('.main-menu--mobile');
    }

    function isMainMenuParent(element) {
        if (!element) {
            return false;
        }

        if (element.classList.contains('main-nav')) {
            return true;
        }

        return element.closest && element.closest('.main-nav');
    }

    function iOSVersion() {
        return parseFloat(
            ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1])
                .replace('undefined', '3_2').replace('_', '.').replace('_', '')
        ) || 0;
    }

    function isBtnMenuShow(element) {
        return element.classList.contains('js-btn-menu-show')
            || (element.closest && element.closest('.js-btn-menu-show'));
    }

    function onBtnMenuStateChange() {
        btnMenu.addEventListener('change', (evt) => {
            if (evt.target.checked) {

                return;
            }

            closeMainMenuItem();
        });
    }

    function onMainMenuItemClick(evt) {
        if (!evt.target.classList.contains('main-menu-item__title')) {
            return;
        }

        let checkedElement = document.getElementById(evt.target.getAttribute('for'));
        if (!checkedElement.checked) {
            closeMainMenuItem();
            evt.target.classList.add('main-menu-item__state--checked');
            return;
        }

        closeMainMenuItem();

        setTimeout(() => checkedElement.checked = false, 100);
    }

    function onWindowClick(evt) {
        if (evt.target.classList.contains('main-menu-item__title')
            || evt.target.classList.contains('main-menu-item__state')
            || evt.target.classList.contains('main-nav-btn-menu__title')
            || evt.target.classList.contains('main-nav-btn-menu')
            || isBtnMenuShow(evt.target)) {
            return;
        }

        if (isMainMenuParent(evt.target)) {
            return;
        }

        closeMainMenu();
    }

    function onKeyDown(evt) {
        if (evt.keyCode === 27) {
            closeMainMenuItem();
            closeMainMenu();
        }
    }

    function onBtnMenuShow() {
        let btn = document.querySelector('.js-btn-menu-show');
        if (!btn) {
            return;
        }

        btn.addEventListener('click', () => {
            if (isOpenMainMenu()) {
                closeMainMenu();
            } else {
                openMainMenu();
            }
        });
    }

    function onBtnMenuClose() {
        document.querySelector('.js-btn-menu-close').addEventListener('click', () => {
            closeMainMenu();
        });
    }

    /**
     * Обработчик события: начало касания
     *
     */
    function onDocumentTouchStart(evt) {
        touchStartX = evt.changedTouches[0].clientX;
        if ((touchStartX > 100) && !isOpenMainMenu()) {
            return;
        }

        mainNavPositionX = mainNav.getBoundingClientRect().left;
        mainNavWidth = mainNav.getBoundingClientRect().width;
        mainNav.classList.add('move');

        document.addEventListener('touchend', onDocumentTouchEnd);
        document.addEventListener('touchmove', onDocumentTouchMove);
    }

    /**
     * Обработчик события: окончания касания
     *
     */
    function onDocumentTouchEnd(evt) {
        let touchEndX = evt.changedTouches[0].clientX;
        let offset = touchEndX - touchStartX;
        let offsetToRight = (offset > 0);

        if (Math.abs(offset) >= 100) {
            if (offsetToRight) {
                openMainMenu();
            } else {
                closeMainMenu();
            }
        }

        mainNav.classList.remove('move');
        mainNav.style.transform = '';

        document.removeEventListener('touchend', onDocumentTouchEnd);
        document.removeEventListener('touchmove', onDocumentTouchMove);
    }

    /**
     * Обработчик события: перемещение указателя
     *
     */
    function onDocumentTouchMove(evt) {
        let scrollOffset = evt.changedTouches[0].clientX - touchStartX;
        let newPositionX = mainNavPositionX + scrollOffset;
        let newPositionXPercent = Math.floor((100 * newPositionX) / mainNavWidth);

        if (newPositionXPercent > 0) {
            return;
        }

        if (window.requestAnimationFrame) {
            requestAnimationFrame(() => {
                translateMainNav(newPositionXPercent);
            });
        } else {
            setTimeout(() => {
                translateMainNav(newPositionXPercent);
            }, 60);
        }
    }

    function translateMainNav(newPositionXPercent) {
        if (!mainNav.classList.contains('move')) {
            return;
        }

        mainNav.style.transform = 'translate3d(' + newPositionXPercent + '%, 0, 0)';
    }

}());

